// extracted by mini-css-extract-plugin
module.exports = {"bot-list":"_1JlFLJOfeF2T0kXI7lA_KK","text-input":"_3jvYVHF63Z0zQE-_kkU2iO","label":"_2WFd5Nkd4MxDLAt3xNpKTd"};